import moment from 'moment';
import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {QuestionnaireService} from "../../../../services/questionnaire/questionnaire.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {debounceTime, takeUntil} from 'rxjs/operators';
import {pipe, Subject} from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
@Component({
  selector: 'app-questionnaire-list',
  templateUrl: './questionnaire-list.component.pug',
  styleUrls: ['./questionnaire-list.component.scss'],
  standalone: false
})
export class QuestionnaireListComponent implements OnInit, OnDestroy {
  @Input() questionnaireList: any;
  @Input() surveyType: any;
  @Output() questionnaire = new EventEmitter();
  questionnaireSelected = 0;
  paginationCriteria = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  }
  searchCriteria = {
    searchOptions: [
      {'label': $localize`Survey`, 'hint': $localize`Survey title`, 'value': 'title'},
      {'label': $localize`Created by`, 'hint': $localize`First or last name`, 'value': 'name'}],
    searchTerm: ''
  }
  sortCriteria = {
    sortOptions: [
      {
        'label': $localize`Last used`,
        'type': "number",
        'value': "last_used"
      },
      {
        'label': $localize`Times used`,
        'type': "frequency",
        'value': "count"
      },
    ],
    sortString: '-last_used',
    sortOrder: ''
  }
  survey_type_map = QuestionnaireService.survey_type_mapping;
  loaded = false;
  private destroy$ = new Subject<void>();
  constructor(
    private questionnaireService: QuestionnaireService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
    private cdr: ChangeDetectorRef
  )
  {
  }
  readonly surveyIcons = {
  exit: 'https://assets.xref.com/omni/shared/exits_icon.svg',
  reference: 'https://assets.xref.com/omni/shared/new_reference_icon.svg',
  pulse: 'https://assets.xref.com/omni/shared/pulse_icon.svg',
  background: 'https://assets.xref.com/omni/shared/background_check.svg'
};


  ngOnInit(): void {
    this.getQuestionnaireList();
  }
  getIcon(q: any) {
  return this.surveyIcons[q?.type || this.surveyType]
      || this.surveyIcons.reference;
  }


  selectedQuestionnaire(questionnaire) {
    this.questionnaireSelected = questionnaire.id;
    this.questionnaire.emit(questionnaire)
  }

  onSortChange(sortString: string): void {
    this.sortCriteria.sortString = sortString;
    this.getQuestionnaireList();
  }

  onSearchChange(searchOutput) {
    this.searchCriteria.searchTerm = searchOutput;
    this.getQuestionnaireList();
  }

  onPageChange(pageNumber) {
    this.paginationCriteria.currentPage = pageNumber;
    this.getQuestionnaireList();
  }

  onPageSizeChange(rowsPerView) {
    this.paginationCriteria.rowsPerView = rowsPerView;
    this.paginationCriteria.currentPage = 1;
    this.getQuestionnaireList();
  }

  getQuestionnaireList() {
    this.loaded = false
    const is_default = null;
    const type = this.survey_type_map[this.surveyType] ? this.survey_type_map[this.surveyType] : 1;
    this.questionnaireService.getQuestionnaires(
      this.searchCriteria.searchTerm, this.paginationCriteria.rowsPerView, this.paginationCriteria.currentPage, this.sortCriteria.sortString, is_default, type, true
    ).pipe(debounceTime(1000), takeUntil(this.destroy$)).subscribe(response => {
      this.loaded = true
      this.questionnaireList = response['data']['questionnaires'];
      this.updateLastUsedDateFormat();
      this.paginationCriteria.total = response['data']['total'];
      this.cdr.detectChanges();
    }, error => {

        console.log(error);
        this.loaded = true
        this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
        }]);
        this.cdr.detectChanges();
    })

  }

  updateLastUsedDateFormat() {
    this.questionnaireList.forEach(question => {
      question.last_used = question.last_used ? moment.utc(question.last_used).local().format('ll') : ''
    });
  }

  ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
  }

}
